module.exports = __webpack_public_path__ + "img/gb-wls.dfb055a3.png";